<script>
export default {
  name: 'languages',
  computed: {
    defaultLanguageCode () {
      return this.$store.state.config.languages.filter(langData => langData.is_default)[0].lang;
    },
    languagesAreAvailable () {
      return !!this.$store.state.config.company.multilang && this.$store.state.config.languages.length > 1;
    },
    availableLanguages () {
      return this.$store.state.config.languages.map(langData => langData.lang);
    }
  },
  methods: {
    getLanguageFieldValues (translations, fieldName, defaultValue, isBoolean = false, defaultObject = false) {
      let fieldTranslations = {};

      for (let i = 0; i < this.availableLanguages.length; i++) {
        let lang = this.availableLanguages[i];

        if (lang === this.defaultLanguageCode) {
          if (defaultValue === '' && defaultObject) {
            fieldTranslations[lang] = defaultObject;
          } else {
            fieldTranslations[lang] = defaultValue;
          }

          continue;
        }

        if (translations[lang] && translations[lang][fieldName]) {
          if (isBoolean) {
            fieldTranslations[lang] = !!parseInt(translations[lang][fieldName], 10);
          } else {
            if (defaultObject) {
              fieldTranslations[lang] = JSON.parse(translations[lang][fieldName]);
            } else {
              fieldTranslations[lang] = translations[lang][fieldName];
            }
          }
        } else {
          if (isBoolean) {
            fieldTranslations[lang] = false;
          } else {
            if (defaultObject) {
              fieldTranslations[lang] = JSON.parse(JSON.stringify(defaultObject));
            } else {
              fieldTranslations[lang] = '';
            }
          }
        }
      }

      return fieldTranslations;
    },
    prepareTranslationsObject (fields, stringifyValue = false) {
      let fieldNames = Object.keys(fields);
      let translationsObject = {};

      for (let i = 0; i < this.availableLanguages.length; i++) {
        if (this.availableLanguages[i] === this.defaultLanguageCode) {
          continue;
        }

        let lang = this.availableLanguages[i];
        translationsObject[lang] = {};

        for (let j = 0; j < fieldNames.length; j++) {
          if (typeof fields[fieldNames[j]][lang] === 'boolean') {
            translationsObject[lang][fieldNames[j]] = +fields[fieldNames[j]][lang];
          } else {
            if (stringifyValue) {
              translationsObject[lang][fieldNames[j]] = JSON.stringify(fields[fieldNames[j]][lang]);
            } else {
              translationsObject[lang][fieldNames[j]] = fields[fieldNames[j]][lang];
            }
          }
        }
      }

      return translationsObject;
    },
    createEmptyTranslationsObject (fields, defaultValue = '') {
      let translationsObject = {};

      for (let i = 0; i < this.availableLanguages.length; i++) {
        let lang = this.availableLanguages[i];
        translationsObject[lang] = {};

        for (let j = 0; j < fields.length; j++) {
          translationsObject[lang][fields[j]] = defaultValue;
        }
      }

      return translationsObject;
    },
    createDefaultTranslationsObject (defaultValue) {
      let translationsObject = {};

      for (let i = 0; i < this.availableLanguages.length; i++) {
        let lang = this.availableLanguages[i];
        translationsObject[lang] = defaultValue;
      }

      return translationsObject;
    },
    createEmptyValueTranslationsObject () {
      let translationsObject = {};

      for (let i = 0; i < this.availableLanguages.length; i++) {
        let lang = this.availableLanguages[i];
        translationsObject[lang] = '';
      }

      return translationsObject;
    },
    changeCurrentLanguageForField (relatedTo, languageCode) {
      this.currentLanguages[relatedTo] = languageCode;
    },
    booleanValueToString (value) {
      return (+value).toString();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/Languages.vue